<template>

  <Wizard
    class     = "wizard"
    icon      = "mdi-alert"
  >
    <div class="text-h5">
      Unable to play media.
    </div>

  </Wizard>

</template>

<script>

// #region Imports

/* Telestream */
import Wizard from '../Wizard';

// #endregion Imports

export default {

  // #region Properties

  components: {
    Wizard
  }

  // #endregion Properties

}

</script>